const projectData = [
  {
    id: 1,
    title: 'E-Fashion E-Commerce Web App',
    description:
      'E-Fashion is a comprehensive e-commerce platform developed as part of my Honours Project. Built with the MERN stack, it offers a seamless shopping experience featuring product filtering, sorting, keyword search, wishlist and cart management, and both guest and authenticated checkout options. The app includes a secure admin interface for full product management (CRUD) and insightful data visualizations. The app emphasizes performance, accessibility, and a clean user experience across devices.',
    technologies: [
      'Bcrypt',
      'Bootstrap',
      'Bootstrap Icons',
      'Cloudinary',
      'ExpressJS',
      'Firebase',
      'JWT',
      'MangoDB',
      'Mongoose',
      'Multer',
      'NodeJs',
      'ReactJS',
      'Recharts',
      'Redux Persist',
      'Redux Toolkit',
      'Render',
      'Streamifier',
      'Swiper.js',
    ],
    sourceCode: 'https://github.com/abdulkadiret/ecommerce-website',
    link: 'https://e-fashion-frontend.onrender.com',
    image: `${process.env.PUBLIC_URL}/images/e-fashion.png`,
  },
  {
    id: 2,
    title: 'Expense Management System',
    description:
      'A full-stack web application developed as part of my Industrial Project module, based on a real client use case. The system streamlines employee expense submissions and approval workflows, providing role-specific access for employees, line managers, and finance/admin staff. Key features include secure authentication (email/password, Google, Facebook), password recovery, rate limiting, account lockout, and real-time tracking of expense status from submission through reimbursement. Built on the MERN stack (MongoDB, Express.js, React, Node.js), the app leverages various tools, libraries, and cloud services to support file uploads (PDFs/images), implement role-based access control (RBAC), and ensure a scalable, maintainable architecture.',
    technologies: [
      'Bcrypt',
      'Bootstrap',
      'Bootstrap Icons',
      'Brevo',
      'Cloudinary',
      'ExpressJS',
      'Firebase',
      'JWT',
      'MangoDB',
      'Mongoose',
      'Multer',
      'NodeJs',
      'ReactJS',
      'Recharts',
      'Redux Persist',
      'Redux Toolkit',
      'Render',
      'Streamifier',
      'Swiper.js',
    ],
    sourceCode: 'https://github.com/abdulkadiret/Expenses-App',
    link: 'https://expenses-app-wx53.onrender.com',
    image: `${process.env.PUBLIC_URL}/images/expense-app.png`,
  },
  {
    id: 0,
    title: 'Portfolio Website - with WordPress',
    description:
      'A responsive 4-page WordPress portfolio built using the Kubio builder. It features tabbed project filtering, a contact form, and SEO-friendly responsive design. To optimize performance and security, the site was converted into a static site using a static page generator plugin and deployed to Netlify—resulting in faster load times, improved security, and zero server maintenance.',
    technologies: [
      'WordPress',
      'Kubio Builder',
      'Astra Theme',
      'PHP',
      'CSS3',
      'JavaScript',
      'Contact Form 7',
      'WP Super Cache',
      'Yoast SEO',
      'Envira Gallery Lite',
      'Font Awesome',
      'Google Fonts',
      'Responsive Design',
      'Simply Static',
      'Netlify',
    ],
    sourceCode: 'https://github.com/',
    link: 'https://akeyportfolio.netlify.app/',
    image: `${process.env.PUBLIC_URL}/images/portfolio-wp.png`,
  },
  {
    id: 3,
    title: 'CYF Quiz',
    description:
      'CYF Quiz is a MERN full-stack application that serves as an interactive learning tool for CYF students to evaluate their knowledge across various training modules. It offers diverse question formats—including checkbox, multiple choice, and radio button questions—spanning topics such as HTML, CSS, JavaScript, React, and Node.js.',
    technologies: [
      'React (React Hooks)',
      'Express.js',
      'mongoDB',
      'SCSS',
      'Bootstrap',
      'React-bootstrap',
      'Git',
      'Github',
      'VSCode',
      'Slack',
      'Heroku',
    ],
    sourceCode: 'https://github.com/CodeYourFuture/project-quiz',
    link: 'https://mern-quiz-app.herokuapp.com',
    image: `${process.env.PUBLIC_URL}/images/quiz-app-1.png`,
  },
  {
    id: 4,
    title: 'Edesia',
    description:
      'Edesia is a full-stack web application designed to connect food banks with volunteer drivers for collecting surplus food from local stores around Glasgow. The app features an interactive map displaying store locations and available food items. Registered drivers can browse and accept delivery requests. Secure authentication and authorization are handled using JWT, supporting distinct roles with tailored content: administrators can manage deliveries by adding, updating, or deleting them, while drivers can view and update their personal profiles after registration.',
    technologies: [
      'React',
      'Node.js',
      'Express.js',
      'PostgreSQL',
      'Knex.js',
      'Bootstrap',
      'CSS',
    ],
    sourceCode: 'https://github.com/CodeYourFuture/edesia',
    link: 'https://edesia-staging.herokuapp.com',
    image: `${process.env.PUBLIC_URL}/images/edesia-1.png`,
  },
  {
    id: 5,
    title: 'Booking App',
    description:
      'The Booking App enables efficient management of restaurant reservations by capturing all booking details. The restaurant concierge can easily view the list of upcoming reservations and update each guest’s status to "seated" upon their arrival, streamlining the check-in process and improving customer service.',
    technologies: [
      'React (React Hooks)',
      'Redux',
      'Redux-persist',
      'React-hook-form',
      'Bootstrap',
      'React-bootstrap',
      'Jest',
      'React-testing-library',
    ],
    sourceCode: 'https://github.com/abdulkadiret/booking-app',
    link: 'https://akey-booking-app.netlify.app/',
    image: `${process.env.PUBLIC_URL}/images/booking-app-1.png`,
  },
  {
    id: 6,
    title: 'ToDo App',
    description:
      'This is a full-featured Todo App that allows users to manage their tasks efficiently. Users can add new todo items, view them in a dynamic list, edit existing tasks, and delete individual items. The app supports marking tasks as completed and undoing that action if needed. It also includes the ability to clear all completed todos in one click and toggle all items as completed or uncompleted. Additionally, users can filter their task list by status — viewing all tasks, only active ones, or just the completed items — for a more organized experience.',
    technologies: ['React (React Hooks)', 'React-bootstrap', 'Bootstrap'],
    sourceCode: 'https://github.com/abdulkadiret/Todo-App',
    link: 'https://epic-payne-61e591.netlify.app/',
    image: `${process.env.PUBLIC_URL}/images/todo-app-1.png`,
  },
];

export default projectData;
